export const LOGIN_FAILED_ERRORS = {
  USER_DOESNT_EXIST_IN_QFLOW: 'AADB2C99002',
  INVALID_SSO_IDP_URL: '27400',
  INVALID_SSO_IDP_INVALID_CLIENT: 'AADB2C90289',
  NON_EXISTENT_SSO_IDP: 'AADB2C90037'
}
